import Contained from './Contained'

export default Contained
